import * as React from "react";
import styled, { css } from "../../../styled/index";
import { FaCheck } from "react-icons/fa";
import lighten from "polished/lib/color/lighten";

const CheckboxWrapperInlineCSS = css`
  display: inline-block;
  &:not(:first-child) {
    margin-left: 10px;
  }
  label {
    display: inline-block;
    margin-left: 6px;
    margin-bottom: 0;
  }
`;

const CheckboxWrapper = styled("div")<{ inline?: boolean }>`
  position: relative;
  ${(props) => props.inline ? CheckboxWrapperInlineCSS : ""};
  label {
    font-weight: 400;
    cursor: pointer;
    display: inline-block;
  }
`;

const CheckboxInput = styled("input")`
  visibility: visible;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin: 0;
`;

const cssChecked = css`
  background: ${({theme}) => theme.colors.primary};
  border: 1px solid ${({theme}) => theme.colors.primary};
  padding-top: -5px;
  line-height: 18px;
`;

const cssCheckedPartial = css`
  border: 1px solid ${({theme}) => theme.colors.primary};
  padding-top: -5px;
  line-height: 18px;
`;

const CheckboxLabel = styled("label")<{ checked: boolean; checkedPartial?: boolean; }>`
  :before {
    text-align: center;
    height: 18px;
    width: 18px;
    margin-bottom: 0;
    content: " ";
    display: inline-block;
    vertical-align: text-bottom;
    border-radius: 3px;
    cursor: pointer;
    transition: 0.15s all;
    background: transparent;
    color: white;
    border: 1px solid #949494;
    ${(props) => props.checkedPartial ? cssCheckedPartial : (props.checked ? cssChecked : "")}
  }
`;

const CheckboxIcon = styled("div")`
    position: absolute;
    top: 50%;
    transform: translateY(-40%);
    left: 3px;
    font-size: 12px;
    pointer-events: none;
    opacity: 0;
    ${(props: { checked: boolean; checkedPartial?: boolean; theme?: ThemeInterface; }) => props.checkedPartial ? css`
      opacity: 1;
      color: ${lighten(0.2, props.theme!.colors.primary)};
    ` : (props.checked ? css`
      opacity: 1;
      color: ${props.theme!.colors.primary_text};
    ` : "")}
`;

export interface CheckboxProps {
  id: string;
  name?: string;
  checked: boolean;
  checkedPartial?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  required?: boolean;
  label?: string | React.ReactNode;
  className?: string;
  inline?: boolean;
}

export const Checkbox = (props: CheckboxProps) => (
  <CheckboxWrapper inline={props.inline} className={props.className}>

    <CheckboxInput
      id={props.id}
      type="checkbox"
      name={props.name}
      onClick={props.onClick}
      onChange={props.onChange}
      required={props.required}
      checked={props.checked}
    />

    <CheckboxLabel
      htmlFor={props.id}
      checked={props.checked}
      checkedPartial={props.checkedPartial}>
      {props.label && <span className="m-l-2">{props.label}</span>}
    </CheckboxLabel>

    <CheckboxIcon
      checkedPartial={props.checkedPartial || false}
      checked={props.checked}>
      <FaCheck/>
    </CheckboxIcon>

  </CheckboxWrapper>
);
